import React from 'react';
import PropTypes from 'prop-types';

import Img from '../Img';
import links from '../../../config/links';

import styles from './popupV3.scss';

export const PopupTypes = {
    INFO: 'info',
    SUCCESS: 'success',
    ERROR: 'error',
};

const icons = {
    error: '/img/v4/triangle-exclamation-red.svg',
};

const LinkedAccountExistsPopup = (props) => {
    const {
        onCancelClick,
    } = props;

    return (
        <div className={styles.overlay} onClick={onCancelClick} data-testid="modal.linked-account-exists">
            <div className={`${styles.popup} ${styles.error}`} style={{ position: 'relative' }}>
                <div className={styles.popupContent}>
                    <div className={styles.left}>
                        <Img src={icons.error} />
                    </div>
                    <div className={styles.right}>
                        <div className={styles.title}>Existing Account Found</div>
                        <p>
                            We found an existing account linked to your email.
                        </p>
                        <p>
                            To continue, please:<br />
                            1. Log in to your existing account<br />
                            2. Go to Settings &gt; Sign-in Accounts<br />
                            3. Link your external account<br />
                        </p>
                        <br />
                            Need help?<br />
                            Contact <a target="_blank" rel="noopener noreferrer" href={links.support} data-testid="modal.linked-account-exists.support-link">Customer Support</a>
                    </div>
                </div>
                <div className={styles.buttonsContainer}>
                    <button type="button" className={`btn btn-primary btn-small text-uppercase`} onClick={onCancelClick} data-testid="modal.linked-account-exists.ok-btn">
                        Ok
                    </button>
                </div>
            </div>
        </div>
    );
};

LinkedAccountExistsPopup.propTypes = {
    onCancelClick: PropTypes.func,
};

LinkedAccountExistsPopup.defaultProps = {
    onCancelClick: () => { },
};

export default LinkedAccountExistsPopup;
